<template>
  <card class="text-center">
    <h3 class="mb-4">Página No Encontrada</h3>

    <div class="links">
      <router-link :to="{ name: 'home' }">Ir a Inicio</router-link>
    </div>
  </card>
</template>

<script>
export default {
  name: 'NotFound',
};
</script>
